module.exports = __webpack_public_path__ + "static/energy_12-3021be4ecd2a8251a7f9edcaaeaf470a.jpg";